<template>
  <form class="auth__form" @submit.prevent="">
    <header>
      <h3>Войти</h3>
    </header>

    <main>
      <Input
        v-model="form.email"
        :error="!editingEmail && ($v.form.email.$error || !!formErrors.email)"
        :error-message="formErrors.email"
        type="email"
        placeholder="Введи email"
        label="Email"
        @input="setEmail"
        @focus="editingEmail = true"
        @blur="editingEmail = false"
      />

      <Input
        v-model="form.password"
        class="input--password"
        :error="$v.form.password.$error || !!formErrors.password"
        :error-message="formErrors.password"
        type="password"
        placeholder="Введи пароль"
        label="Пароль"
        @input="setPassword"
      />

      <router-link to="/resetpassword"> Забыл пароль? </router-link>

      <Button
        class="button--login"
        :disabled="!canSubmitForm"
        :loading="metaLoginIn"
        @click="submitLogin"
      >
        Войти
      </Button>

      <SocialIcons />
    </main>

    <footer>
      <p>
        Нет аккаунта?
        <router-link to="/registration"> Регистрация </router-link>
      </p>
    </footer>
  </form>
</template>

<script>
import { mapState } from 'vuex';
import Input from '@/components/UiKit/v2/Input/index.vue';
import Button from '@/components/UiKit/v2/Button/index.vue';
import SocialIcons from './components/SocialNetworksAuth.vue';
import { required, email } from 'vuelidate/lib/validators';

export default {
  components: {
    Input,
    Button,
    SocialIcons
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
        rememberMe: 1
      },
      editingEmail: false
    };
  },
  validations: {
    form: {
      email: { required, email },
      password: { required }
    }
  },
  computed: {
    ...mapState('security', {
      metaLoginIn: state => state.meta.loginIn,
      authErrors: state => state.data.authErrors
    }),
    canSubmitForm() {
      return !this.$v.form.$invalid;
    },
    formErrors() {
      const errors = {
        email: '',
        password: ''
      };
      const errorMessages = {
        fieldIsRequired: 'Обязательное поле',
        enterCorrectEmail: 'Некорректный e-mail'
      };

      if (this.$v.form.email.$dirty && this.$v.form.email.$error) {
        if (!this.$v.form.email.required) {
          errors.email = errorMessages.fieldIsRequired;
        } else if (!this.$v.form.email.email) {
          errors.email = errorMessages.enterCorrectEmail;
        }
      }
      if (this.$v.form.password.$dirty && this.$v.form.password.$error) {
        if (!this.$v.form.password.required) {
          errors.password = errorMessages.fieldIsRequired;
        }
      }

      this.authErrors.forEach(error => {
        if (error.field === 'email') {
          errors.email = error.message;
        }
        if (error.field === 'password') {
          errors.password = error.message;
        }
      });

      return errors;
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.$store.dispatch('security/clearAuthErrors');
      }
    }
  },
  destroyed() {
    if (this.authErrors.length > 0) {
      this.$store.dispatch('security/clearAuthErrors');
    }
  },
  methods: {
    setEmail(value) {
      this.form.email = value;
      this.$v.form.email.$touch();
    },
    setPassword(value) {
      this.form.password = value;
      this.$v.form.password.$touch();
    },
    submitLogin() {
      if (this.metaLoginIn) {
        return;
      }
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$store.dispatch('security/login', this.form);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../style/utils';

form.auth__form {
  margin-top: 40px;

  main {
    @include uiFont;
    @extend %text-500-14;
    display: flex;
    flex-direction: column;
    color: $ui-light-grey-4-5-contrast;
    margin-bottom: 60px;

    a {
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .input__wrapper:not(:nth-of-type(1)) {
    margin-top: 14px;
  }

  .input__wrapper.input--password {
    margin-bottom: 14px;
  }

  .button--login {
    margin-top: 30px;
  }
}
</style>
